// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCnagsaN0OWgc9XvYPexqMSDTjbBXcshTc",
  authDomain: "photo-puzzle-36956.firebaseapp.com",
  projectId: "photo-puzzle-36956",
  storageBucket: "photo-puzzle-36956.appspot.com",
  messagingSenderId: "521985615864",
  appId: "1:521985615864:web:8f17a7367b01141ccd180d",
  measurementId: "G-SM107XNP02"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);